const BreakpointManager = (function () {
  // Define breakpoints in order from smallest to largest
  const breakpointOrder = ['default', 'sm', 'md', 'lg', 'xl'];
  const breakpoints = {
    default: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  };

  let currentBreakpoint = getBreakpointName(window.innerWidth);
  const subscribers = new Set();

  // Helper function to determine the current breakpoint name
  function getBreakpointName(width) {
    for (let i = breakpointOrder.length - 1; i >= 0; i--) {
      const bpName = breakpointOrder[i];
      if (width >= breakpoints[bpName]) {
        return bpName;
      }
    }
    return 'default';
  }

  // Function to handle window resize events
  function onResize() {
    const newBreakpoint = getBreakpointName(window.innerWidth);
    if (newBreakpoint !== currentBreakpoint) {
      currentBreakpoint = newBreakpoint;
      // Notify all subscribers
      subscribers.forEach((callback) => callback());
    }
  }

  // Attach the resize event listener
  window.addEventListener('resize', onResize);

  return {
    /**
     * Subscribe a callback function to breakpoint changes.
     * @param {Function} callback - Function to be called when breakpoint changes.
     */
    subscribe(callback) {
      if (typeof callback === 'function') {
        subscribers.add(callback);
      }
    },

    /**
     * Unsubscribe a previously subscribed callback function.
     * @param {Function} callback - Function to be removed from subscribers.
     */
    unsubscribe(callback) {
      subscribers.delete(callback);
    },

    /**
     * Get the current breakpoint name.
     * @returns {string} - The name of the current breakpoint.
     */
    getCurrentBreakpoint() {
      return currentBreakpoint;
    },

    /**
     * Comparison functions comparing the current breakpoint to a given breakpoint.
     */

    /**
     * Checks if current breakpoint is less than the given breakpoint.
     * @param {string} bp - Breakpoint name to compare with current breakpoint.
     * @returns {boolean}
     */
    lt(bp) {
      this.validateBreakpoint(bp);
      return breakpointOrder.indexOf(currentBreakpoint) < breakpointOrder.indexOf(bp);
    },

    /**
     * Checks if current breakpoint is greater than the given breakpoint.
     * @param {string} bp - Breakpoint name to compare with current breakpoint.
     * @returns {boolean}
     */
    gt(bp) {
      this.validateBreakpoint(bp);
      return breakpointOrder.indexOf(currentBreakpoint) > breakpointOrder.indexOf(bp);
    },

    /**
     * Checks if current breakpoint is less than or equal to the given breakpoint.
     * @param {string} bp - Breakpoint name to compare with current breakpoint.
     * @returns {boolean}
     */
    lte(bp) {
      this.validateBreakpoint(bp);
      return breakpointOrder.indexOf(currentBreakpoint) <= breakpointOrder.indexOf(bp);
    },

    /**
     * Checks if current breakpoint is greater than or equal to the given breakpoint.
     * @param {string} bp - Breakpoint name to compare with current breakpoint.
     * @returns {boolean}
     */
    gte(bp) {
      this.validateBreakpoint(bp);
      return breakpointOrder.indexOf(currentBreakpoint) >= breakpointOrder.indexOf(bp);
    },

    /**
     * Checks if current breakpoint is equal to the given breakpoint.
     * @param {string} bp - Breakpoint name to compare with current breakpoint.
     * @returns {boolean}
     */
    eq(bp) {
      this.validateBreakpoint(bp);
      return currentBreakpoint === bp;
    },

    /**
     * Validates if the given breakpoint is defined.
     * @param {string} bp - Breakpoint name to validate.
     * @throws Will throw an error if breakpoint is invalid.
     */
    validateBreakpoint(bp) {
      if (!breakpointOrder.includes(bp)) {
        throw new Error(`Invalid breakpoint: ${bp}`);
      }
    },
  };
})();

export default BreakpointManager;
